import React from 'react';

/**
 * Small inline spinner for use inside buttons or next to loading text.
 * size: px dimension of the circle (default 12)
 * color: stroke color (default 'currentColor')
 */
export default function Spinner({ size = 12, color = 'currentColor', style = {} }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      style={{ display: 'inline-block', verticalAlign: 'middle', flexShrink: 0, animation: 'spin 0.75s linear infinite', ...style }}
      aria-hidden="true"
    >
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      <circle cx="8" cy="8" r="6" stroke={color} strokeWidth="2.5" strokeOpacity="0.25" />
      <path d="M8 2a6 6 0 0 1 6 6" stroke={color} strokeWidth="2.5" strokeLinecap="round" />
    </svg>
  );
}
